import { archiverUrl, fetchWithAuthorization } from '../helpers/utils';

const RecommendationApi = {
    fetch: (urlParams: string): Promise<Response> =>
        fetchWithAuthorization(`${archiverUrl()}/recommendation?${urlParams}`),
};

export default RecommendationApi;
